import createAction from 'model/actions/utilities/createAction';
import createPassiveAction from 'model/actions/utilities/createPassiveAction';

// Adaptability and cunning, focusing on survival and influence
// rather than mere accumulation of wealth or power.
// The benefits derived at each level enhance the protagonist's ability to navigate the perilous
// environments they encounter, whether through stealth, force, or leadership, aligning with the overarching goal of enduring the journey.

const STATUS_METRICS = {
  status: {
    intimidation: 3,
    influence: -0.5,
    respect: -0.5
  }
};
// Helper function for creating generic actions
const createCrimeAction = (title, description) => {
  return createAction('Continue', description, () => STATUS_METRICS, `advanced: ${title}`);
};

//"in the shadows of fallen cities, fortune is scavenged.",
const scrounger = createCrimeAction('Scrounger', 'fortune favors the bold, even amongst ruins.');
// Where morality fades, survival takes precedence."),
//TODO: Unlocks raiding tactics for better loot from abandoned sites.
const looter = createCrimeAction('Looter', "raiding the remnants and claiming what's left behind.");
//"Stealing not just belongings, but pieces of forgotten lives.",
//TODO: Improves stealth, reducing risk when stealing in populated areas.
const pickpocket = createCrimeAction('Pickpocket', "hands swift, a pickpocket's haul grows.");
//description: formatMessage("Violence mirrors desperation, a reflection of the dark."),
//TODO: Grants a bonus to intimidation, influencing interactions with weaker travelers.
const mugger = createCrimeAction('Mugger', 'the desperate confronted. resources taken by force.');
//description: formatMessage("Power dictates right, seizing by force."),
//TODO: Enhances combat skills during robberies, increasing success rates.
const robber = createCrimeAction('Robber', 'power dictates right. seizing by force.');
// TODO: Benefit: Expertise in silent entry improves success rate in burglary.
// Event Code: Access to high-value targets.
const burglar = createCrimeAction('Burglar', 'the silence of sanctuaries broken, treasures claimed in whispers.');
// TODO: Benefit: Ambush travelers or caravans for resources.
//description: formatMessage("The roads less guarded bear the shadow of ambush."),
const highwayman = createCrimeAction('Highwayman', 'from shadows, claiming dominion over roads less traveled.');
// TODO: Command a group for larger raids, increasing resources.
//description: formatMessage("Fear and might, the lawless expanses under your rule."),
const bandit = createCrimeAction('Bandit', 'fear and might. the lawful bend their knee.');
// TODO: Influence over a larger territory, increasing passive gains.
//description: formatMessage("Among outcasts, a realm of shadow carved by leadership."),
const brigand = createCrimeAction('Brigand', 'among outcasts, a realm of shadow carved by leadership.');
// TODO: Legendary status deters attacks and opens new opportunities
const outlaw = createCrimeAction('Outlaw Legend', 'myth and dread whispered across the lawless land.');

const passiveCrime = amount =>
  createPassiveAction({
    resources: {
      health: -amount,
      ammo: Math.round(10 * amount),
      coins: amount
    }
  });

export { bandit, brigand, burglar, highwayman, looter, mugger, outlaw, passiveCrime, pickpocket, robber, scrounger };
